<template>
  <div>
    <canvas
      id="outputCanvas"
      :width="width"
      :height="height"
      :style="{ width: width + 'px', height: height + 'px' }"
    ></canvas>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  getCurrentInstance,
  watch,
  reactive,
  toRefs,
  onMounted,
  nextTick,
} from "vue";
let outputCanvas = "";
let ctx = "";
export default defineComponent({
  setup(props, context) {
    const state = reactive({
      text: "",
      width: 100,
      height: 100,
    });
    const init = (item) => {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          state.width = item.width * 8;
          state.height = item.height * 8;
          nextTick(() => {
            ctx.clearRect(0, 0, state.width, state.height);
            ctx.drawImage(img, 0, 0, state.width, state.height);
            setTimeout(() => {
              let imageData = ctx.getImageData(0, 0, state.width, state.height);
              resolve(imageData)
            }, 200);
          });
        };
        img.src = item.image_address;
      });
    };

    onMounted(() => {
      outputCanvas = document.getElementById("outputCanvas");
      ctx = outputCanvas.getContext("2d");
    });

    return {
      ...toRefs(state),
      init,
    };
  },
});
</script>
<style scoped>
#outputCanvas{
    position: fixed;
    left: -200%;
    top: -300%;
}
</style>
